__turbopack_context__.v({
  "collapse": "NwwAoW_collapse",
  "disabled": "NwwAoW_disabled",
  "open": "NwwAoW_open",
  "panelContent": "NwwAoW_panelContent",
  "panelTitle": "NwwAoW_panelTitle",
  "wrapper": "NwwAoW_wrapper",
});
